import { memo, useEffect } from "react"
import { BrowserRouter, Routes, Route, useLocation, useMatches } from "react-router";
import { Button, Center, Container, Stack, Portal, Text, HStack, VStack } from "@chakra-ui/react"
import Header from "./Header";

import Home from "@/pages/home"
import Product from "@/pages/product"
import Cart from "@/pages/cart"
import Checkout from "@/pages/checkout"
import Invoice from "@/pages/invoice"
import Thank from "@/pages/thank"
import Order from "@/pages/order"
import OrderPay from "@/pages/order-pay"
import OrderList from "@/pages/order-list"
import { CartProvider } from "contexts/cart";
import { AppProvider, useApp } from "contexts/app";
import { AuthProvider, useAuth } from "contexts/auth";
import { StoreProductProvider, useStoreProduct } from "contexts/store_product";
import { Dialog } from "@chakra-ui/react"

import { Spinner } from "@chakra-ui/react"
import ProductSearchBox from "components/product/search"
import AddToCart from "../common/AddToCart"
import Menu from "./Menu"
import Policy from "@/pages/policy";
import Footer from "./Footer";
import Profile from "@/pages/profile"
import Point from "@/pages/point"
import ShopRouters from "../common/Router"
import { useStore } from "contexts/store"
import { ChatProvider } from "contexts/chat"
import AnalyticService from "services/analytic"
const analyticService = new AnalyticService()
const ShopLayout = () => {
    const { showProductSearch, productSearchList, processing, setProcessing } = useApp();

    let location = useLocation()
    const { store } = useStore();
    useEffect(() => {
        console.log("location", location)

    }, [location]);

    useEffect(() => {
        analyticService.track({ event: "page_view", path:location?.pathname });
    }, [])


    return (
        <CartProvider>



            {/* <div style={{ position: "fixed", top: 0, left: 0, height: "100vh", width: "100vw", zIndex: 2147483647, display: processing ? "block" : "none"}} onClick={e => {  return false }}>
                <div style={{ marginTop: 50 }}>
                    <Center>
                        <Spinner color="teal.500" size="lg" />
                    </Center>

                </div>

            </div> */}
            <Container maxW={"md"} padding={0}>
                <div style={{ padding: 8, minHeight: "100vh" }}>
                    <Stack >
                        {!showProductSearch &&
                            <Header></Header>
                        }
                        {showProductSearch &&

                            <ProductSearchBox></ProductSearchBox>
                        }
                        <div style={{ display: showProductSearch ? "none" : "block" }}>
                            <ShopRouters></ShopRouters>
                        </div>

                    </Stack>


                </div>
                <Footer></Footer>
                <AddToCart></AddToCart>

                <Menu></Menu>

                <Dialog.Root lazyMount open={processing} onOpenChange={(e) => setProcessing(e.open)} closeOnEscape={false} closeOnInteractOutside={false}>

                    <Portal>
                        <Dialog.Backdrop />
                        <Dialog.Positioner>

                            <Container maxW={"md"} >

                                <div style={{ backgroundColor: "white", padding: 8, borderRadius: 8, marginTop: 16 }}>

                                    <Center>
                                        <VStack>

                                            <Spinner size="lg" color={store?.web?.theme?.colorPalette?.name} />
                                            <Text >Đang xử lý</Text>
                                        </VStack>

                                    </Center>
                                </div>
                            </Container>



                        </Dialog.Positioner>
                    </Portal>
                </Dialog.Root>

            </Container>





        </CartProvider>

    )
}
const ShopLayoutWrap = () => {
    return (
        <AppProvider>
            <AuthProvider>
                <ChatProvider>
                    <StoreProductProvider>
                        <ShopLayout></ShopLayout>
                    </StoreProductProvider>
                </ChatProvider>



            </AuthProvider>
        </AppProvider>
    )
}

export default memo(ShopLayoutWrap)